import {
  ApplicationState,
  EodStateResponse,
  MessageByKey
} from './application.model';

const reducers = {
  addHtmlContent: (state: ApplicationState, htmlContent: MessageByKey) => {
    const exists = state.htmlContent.some(
      ({ messageKey }) => messageKey === htmlContent.messageKey
    );
    if (!exists) {
      return { ...state, htmlContent: [...state.htmlContent, htmlContent] };
    }
    const newHtmlContentState = state.htmlContent.map((item) =>
      item.messageKey === htmlContent.messageKey ? htmlContent : item
    );
    return {
      ...state,
      htmlContent: newHtmlContentState
    };
  },
  storeAppVersion: (
    state: ApplicationState,
    bffVersion: string,
    adapterVersion: string
  ) => ({
    ...state,
    bffVersion,
    adapterVersion
  }),
  storeSigmaAvailability: (
    state: ApplicationState,
    sigmaAvailable: boolean
  ) => ({
    ...state,
    sigmaAvailable
  }),
  storeEodStatus: (state: ApplicationState, eodState: EodStateResponse) => ({
    ...state,
    eodState: { status: eodState.eodProcessing, date: eodState.businessDate }
  }),
  enableKisaLoginPageVisibility: (state: ApplicationState) => ({
    ...state,
    kisaLoginPageVisibility: true
  }),
  disableKisaLoginPageVisibility: (state: ApplicationState) => ({
    ...state,
    kisaLoginPageVisibility: false
  }),
  disablePayments: (state: ApplicationState) => ({
    ...state,
    payments: { paymentsAvailability: false }
  }),
  enablePayments: (state: ApplicationState) => ({
    ...state,
    payments: { paymentsAvailability: true }
  })
};

export default reducers;
